function alertParameterDealersController(alertsFrameworkService, hierarchyService) {
    const $ctrl = this;

    $ctrl.areAmsDealersLoading = false;

    $ctrl.$onInit = function () {
        loadAmsDealers();

        $ctrl.amsDealerIds = alertsFrameworkService.getKeyArrayFromCsv($ctrl.model);
    };

    /* Handle Model Changes on the Parent */
    $ctrl.$onChanges = function(changes) {
        if (changes.model){
            const newKeys = alertsFrameworkService.getKeyArrayFromCsv(changes.model.currentValue);
            const arraysEqual =
                newKeys.length === $ctrl.amsDealerIds.length
                && newKeys.every((value, index) => value === $ctrl.amsDealerIds[index]);

            if (!arraysEqual)
            {
                $ctrl.amsDealerIds = newKeys;
            }
        }
    }

    $ctrl.amsDealersChanged = (item, model) => {
        const csvValue = alertsFrameworkService.getCsvFromKeyArray($ctrl.amsDealerIds);

        $ctrl.onUpdate({csvValue: csvValue});
    };

    function loadAmsDealers() {
        $ctrl.areAmsDealersLoading = true;

        return hierarchyService
            .getAmsDealers($ctrl.subscriberKey)
            .then((amsDealers) => {
                $ctrl.amsDealers = amsDealers.map((dealer) => {
                    dealer.name = dealer.hierarchyNodeNameOverride || dealer.hierarchyNodeName;
                    dealer.id = dealer.hierarchyNodeKey;

                    return dealer;
                });

                $ctrl.areAmsDealersLoading  = false;
            });
    }
}

angular
    .module("angus.components")
    .component("alertParameterDealers", {
        controller: alertParameterDealersController,
        bindings: {
            subscriberKey: "<",
            label: "<",
            model: "<",
            isReadOnly: "<",
            onUpdate: "&"
        },
        template: `
<label class="control-label" for="amsDealers">{{$ctrl.label || 'Dealers'}}
    <i class="fa fa-spinner fa-spin" data-fade-toggle="areAmsDealersLoading"></i></label>

<ui-select 
    class="alert-select"
	multiple 
	ng-model="$ctrl.amsDealerIds" 
	ng-disabled="!$ctrl.amsDealers.length || $ctrl.isReadOnly" 
	on-select="$ctrl.amsDealersChanged($item, $model)" 
	on-remove="$ctrl.amsDealersChanged($item, $model)"
>
    <ui-select-match placeholder="Select dealers...">{{$item.name}}</ui-select-match>
    <ui-select-choices repeat="amsDealer.id as amsDealer in $ctrl.amsDealers | filter: {name: $select.search}">
        {{amsDealer.name}}</ui-select-choices>
</ui-select>
		`
    });
